webpackJsonp([1],{

/***/ "/Pp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Skl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'SETTING',
	data: function data() {
		return {
			locations: [{ name: "PENDING", base: "/ftp.tv.pending", api: "https://192.168.40.31:5001/webapi", info: "info query", auth: "auth", createShare: "test", deleteShare: "delete", logout: "logout" }, { name: "PENDING2", base: "/ftp.tv.pending", api: "https://192.168.40.31:5001/webapi", info: "info query", auth: "auth", createShare: "test", deleteShare: "delete", logout: "logout" }]
		};
	},

	methods: {
		checkformat: function checkformat() {
			this.axios.post(this.$bus.mamServer + "/checkformat", { key: "secretcode2018" }).then(function (result) {

				var data = result.data;
				console.log(result);
				if (data.status === "success") {}
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	created: function created() {
		var _this = this;

		//get locations
		this.axios.post(this.$bus.mamServer + "/getLocationInfos").then(function (result) {
			_this.locationInfos = result.data;
		}).catch(function (err) {
			console.log(err);
		});
	}
});

/***/ }),

/***/ "63qs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7JBw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'topMenu',
	data: function data() {
		return {
			count: 0,
			searchValue: '',
			showFilter: false,
			showSetting: false,
			showStatus: false,
			searchFilters: [],
			searchFavorites: ["@recent", "@occurs"],
			displayFavorites: false,
			statusInfo: [],
			isLogin: this.$bus.login
		};
	},

	methods: {
		search: function search() {
			var _this = this;

			if (this.$route.name !== "HOME") this.$router.push("/home");
			setTimeout(function () {
				_this.$bus.$emit('searchChanged', { search: _this.searchValue, filters: _this.searchFilters });
			}, 100);
		},
		logout: function logout() {
			localStorage.removeItem("token");
			localStorage.removeItem("user");
			this.$bus.login = false;
			this.isLogin = false;
			this.$router.push("/");
		},
		toggleFilter: function toggleFilter() {
			this.showFilter = !this.showFilter;
		},
		toggleSetting: function toggleSetting() {
			this.showStatus = false;
			this.showSetting = !this.showSetting;
		},
		toggleStatus: function toggleStatus() {
			this.showSetting = false;
			this.showStatus = !this.showStatus;
			if (this.showStatus) this.updateStatus();
		},
		updateStatus: function updateStatus() {
			var _this2 = this;

			//get new status..
			this.axios.post(this.$bus.mamServer + "/status").then(function (result) {
				_this2.statusInfo = result.data;
				var currentTime = getTime();
				_this2.statusInfo.forEach(function (location) {
					//console.log(currentTime+"::"+location.lastBeat)
					var diff = Number(currentTime.replace(/:/g, "")) - Number(location.lastBeat.replace(/:/g, ""));
					if (diff > 500) location.status = "OFFLINE";
				});
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	created: function created() {
		var _this3 = this;

		this.$bus.$on("loggedin", function () {
			console.log("logged in");
			_this3.isLogin = true;
		});
	}
});

function getTime() {
	var date = new Date();
	var time = ('0' + date.getHours()).slice(-2) + ":" + ('0' + date.getMinutes()).slice(-2) + ":" + ('0' + date.getSeconds()).slice(-2);
	return time;
}

/***/ }),

/***/ "92wT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SETTING_vue__ = __webpack_require__("xcFv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9065ba9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SETTING_vue__ = __webpack_require__("HIbB");
function injectStyle (ssrContext) {
  __webpack_require__("TfZk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9065ba9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SETTING_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9065ba9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SETTING_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "95NA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Home"},[(_vm.pages)?_c('div',{staticStyle:{"float":"left","margin-left":"10px"}},[_vm._v("\n\tPages: "),_vm._l((_vm.pages+1),function(n){return _c('span',{staticClass:"pageNumber",attrs:{"name":'page'+n},on:{"click":function($event){_vm.changePage(n)}}},[_vm._v(_vm._s(n))])})],2):_vm._e(),_vm._v(" "),(_vm.searchResults.length||_vm.searchResult.length)?_c('div',{staticStyle:{"float":"left","margin-left":"10px"}},[_vm._v("Found ("+_vm._s(_vm.searchResults.length||_vm.searchResult.length)+")")]):_vm._e(),_c('br'),_c('br'),_vm._v(" "),_vm._l((_vm.searchResult),function(item,index){return (_vm.searchResult.length)?_c('div',{staticClass:"searchOuter"},[_c('div',{staticClass:"searchItem",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.toggle(index)}}},[_c('button',{staticClass:"editButton"},[_vm._v("EDIT")]),_vm._v(" "),_c('button',{staticClass:"editButton",on:{"click":function($event){_vm.download(item.path,item.location)}}},[_vm._v("DOWNLOAD")]),_vm._v(" "),_c('div',{staticClass:"searchItemName",on:{"click":function($event){_vm.toggle(index)}}},[_c('p',{staticClass:"location"},[_vm._v("["+_vm._s(item.location)+"]")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(item.name))])]),_vm._v("\n\t\t\tFile Path: "+_vm._s(item.path)+"\n\t\t\t\n\t\t\t"),_c('transition',{attrs:{"name":"dropdown"}},[(_vm.show[index])?_c('div',{staticClass:"itemProperties"},[(_vm.searchOccurs)?_c('table',_vm._l((item.multiple),function(location){return _c('tr',[_c('td',{staticClass:"tField location"},[_vm._v(_vm._s(location.location))]),_c('td',[_vm._v(_vm._s(location.path))])])})):_c('table',[_c('table',{staticStyle:{"display":"inline"},attrs:{"width":"500"}},[_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Location")]),_c('td',[_vm._v(_vm._s(item.location))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Category")]),_c('td',[_vm._v(_vm._s(item.category))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Tags")]),_c('td',[_vm._v(_vm._s(item.tags))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("File Size")]),_c('td',[_vm._v(_vm._s(item.size))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Modified")]),_c('td',[_vm._v(_vm._s(item.mtime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Created")]),_c('td',[_vm._v(_vm._s(item.ctime))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Added")]),_c('td',[_vm._v(_vm._s(item.added))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Profile")]),_c('td',[_vm._v(_vm._s(item.profile))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Duration")]),_c('td',[_vm._v(_vm._s(item.duration))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Width")]),_c('td',[_vm._v(_vm._s(item.width))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Height")]),_c('td',[_vm._v(_vm._s(item.height))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Frame Rate")]),_c('td',[_vm._v(_vm._s(item.frameRate))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Bitrate")]),_c('td',[_vm._v(_vm._s(item.bitrate))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Frame mode")]),_c('td',[_vm._v(_vm._s(item.frameMode))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Standard")]),_c('td',[_vm._v(_vm._s(item.standard))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Scan type")]),_c('td',[_vm._v(_vm._s(item.scanType))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"tField"},[_vm._v("Aspect")]),_c('td',[_vm._v(_vm._s(item.aspect))])])]),_vm._v(" "),_c('div',{staticStyle:{"display":"inline","float":"right","padding-left":"8px"},attrs:{"width":"100%"}},[_vm._v("\n\t\t\t\t\t\tNotes"),_c('br'),_c('textarea',{staticClass:"notes",attrs:{"rows":"20","cols":"50","name":item.name}}),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.saveNote($event)}}},[_vm._v("Save")])])])]):_vm._e()])],1)]):_vm._e()}),_vm._v(" "),(!_vm.searchResult.length)?_c('div',[_c('h1',[_vm._v("No result")])]):_vm._e(),_vm._v(" "),_c('br')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "BaCP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CP5k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"_setting"}},[_c('h1',[_vm._v("SETTING")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"menuTab"},[_vm._v("GENERAL")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("USERS")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("GROUP")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("LOCATIONS")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("CATEGORIES")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("TAGS")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("BACKUP")]),_vm._v(" "),_c('div',{staticClass:"menuTab",on:{"click":_vm.checkformat}},[_vm._v("CHECK FORMAT")])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"location settingContent"},[_vm._v("\n\t\n\t\tLOCATION SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD LOCATION"),_c('br'),_vm._v("\n\t\tREMVOE LOCATION"),_c('br'),_vm._v("\n\t\tEDIT LOCATION"),_c('br'),_vm._v("\n\t\t\n\t\t//locations....\n\t\t"),_c('hr'),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('div',[_c('table',{staticClass:"locationTable",staticStyle:{"width":"600px"}},[_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Name\t\t")]),_c('td',[_vm._v(_vm._s(location.name))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Base Path\t")]),_c('td',[_vm._v(_vm._s(location.base))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("API\t\t\t")]),_c('td',[_vm._v(_vm._s(location.api))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("INFO\t\t")]),_c('td',[_vm._v(_vm._s(location.info))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("AUTH\t\t")]),_c('td',[_vm._v(_vm._s(location.auth))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Create Share")]),_c('td',[_vm._v(_vm._s(location.createShare))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Delete Share")]),_c('td',[_vm._v(_vm._s(location.deleteShare))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Logout\t\t")]),_c('td',[_vm._v(_vm._s(location.logout))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"}}),_vm._v("ALLOW SEARCH \t"),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"}}),_vm._v("ALLOW DOWNLOAD\t"),_c('br'),_vm._v(" "),_c('hr')])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general settingContent"},[_vm._v("\n\t\n\t\tGENERAL SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tSHOW PAGES "),_c('input',{attrs:{"type":"checkbox","name":"showPage"}}),_c('br'),_vm._v("\n\t\tITEMS PER PAGE "),_c('input',{attrs:{"type":"number","name":"perPage","width":"3"}}),_c('br'),_vm._v("\n\t\tMAXIMUM LOGIN TRIES "),_vm._v("\"loginTries\" width=\"3\">"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user settingContent"},[_vm._v("\n\t\n\t\tUSER SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD USER"),_c('br'),_vm._v("\n\t\tREMVOE USER"),_c('br'),_vm._v("\n\t\tEDIT USER"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group settingContent"},[_vm._v("\n\t\n\t\tGROUP SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD GROUP"),_c('br'),_vm._v("\n\t\tREMVOE GROUP"),_c('br'),_vm._v("\n\t\tEDIT GROUP"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories settingContent"},[_vm._v("\n\t\n\t\tCATEGORIES SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD CATEGORY"),_c('br'),_vm._v("\n\t\tREMVOE CATEGORY"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags settingContent"},[_vm._v("\n\t\n\t\tTAGS SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD TAGS"),_c('br'),_vm._v("\n\t\tREMVOE TAGS"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backup settingContent"},[_vm._v("\n\t\n\t\tBACKUP SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tBackup Now"),_c('br'),_vm._v("\n\t\tBackup Schedule"),_c('br'),_vm._v("\n\t\tRestotre Backup"),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DEyW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"_filter"}},[_c('div',{staticClass:"menuHandle"},[_vm._v("Filters"),_c('button',{staticClass:"closeButton",on:{"click":_vm.closeFilter}},[_vm._v("x")])]),_vm._v(" "),_c('div',{staticClass:"menuBody"},[_c('table',[_c('tr',[_c('td',[_vm._v("Result Limits")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterLimits),expression:"filterLimits"}],domProps:{"value":(_vm.filterLimits)},on:{"change":_vm.updateFilter,"input":function($event){if($event.target.composing){ return; }_vm.filterLimits=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Last days")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterLastDays),expression:"filterLastDays"}],domProps:{"value":(_vm.filterLastDays)},on:{"change":_vm.updateFilter,"input":function($event){if($event.target.composing){ return; }_vm.filterLastDays=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Location")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterLocations),expression:"filterLocations"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterLocations=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateFilter]}},[_c('option',{attrs:{"value":""}},[_vm._v("ALL")]),_vm._v(" "),_c('option',{attrs:{"value":"PENDING"}},[_vm._v("PENDING")]),_vm._v(" "),_c('option',{attrs:{"value":"HOU-2"}},[_vm._v("HOU-2")]),_vm._v(" "),_c('option',{attrs:{"value":"ISILON"}},[_vm._v("ISILON")])])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Category")]),_c('td',[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterCategory),expression:"filterCategory"}],on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.filterCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.updateFilter]}},_vm._l((_vm.categories),function(category){return _c('option',{domProps:{"value":category}},[_vm._v(_vm._s(category.toUpperCase()))])}))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Tags")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterTags),expression:"filterTags"}],domProps:{"value":(_vm.filterTags)},on:{"change":_vm.updateFilter,"input":function($event){if($event.target.composing){ return; }_vm.filterTags=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Width")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterWidth),expression:"filterWidth"}],domProps:{"value":(_vm.filterWidth)},on:{"change":_vm.updateFilter,"input":function($event){if($event.target.composing){ return; }_vm.filterWidth=$event.target.value}}})])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Height")]),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filterHeight),expression:"filterHeight"}],domProps:{"value":(_vm.filterHeight)},on:{"change":_vm.updateFilter,"input":function($event){if($event.target.composing){ return; }_vm.filterHeight=$event.target.value}}})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ephl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"_login"}},[_c('img',{attrs:{"src":"http://vietv.com/develop/webprojects/projects/vietv/skins/vietv/images/logo.png"}}),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"form"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"placeholder":"username"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"type":"password","placeholder":"password"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_c('br'),_vm._v(" "),_c('button',{on:{"click":_vm.login}},[_vm._v("Submit")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'Home',
	data: function data() {
		return {
			searchResults: [],
			searchResult: [],
			pages: 0,
			perpage: 25,
			show: [],
			sortMethod: 'date',
			searchOccurs: false
		};
	},

	methods: {
		saveNote: function saveNote($event) {
			//console.log($event)
			var textArea = $event.target.previousElementSibling;
			var text = textArea.value;
			var name = textArea.attributes.name.value;
			//save notes
			this.axios.post(this.$bus.mamServer + "/saveNote", { name: name, text: text }).then(function (result) {

				var data = result.data;
				if (data.status === "success") {
					console.log("save note succeeded...");
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		changePage: function changePage(n) {
			var start = n === 1 ? 0 : (n - 1) * this.perpage - 1;
			this.searchResult = this.searchResults.slice(start, start + this.perpage);
			document.getElementsByClassName("pageNumberSelected")[0].classList.remove("pageNumberSelected");
			document.getElementsByName("page" + n)[0].classList.add("pageNumberSelected");
		},
		getNote: function getNote(name) {
			this.axios.post(this.$bus.mamServer + "/getNote", { name: name }).then(function (result) {

				var data = result.data;
				if (data.status === "success") document.getElementsByName(name)[0].value = data.text;
			}).catch(function (err) {
				console.log(err);
			});
		},

		expandItem: {},
		toggle: function toggle(index) {
			var _this = this;

			var display = !this.show[index];

			if (display) {
				this.show.forEach(function (item, index) {
					_this.show[index] = false;
				});
				if (!this.searchOccurs) this.getNote(this.searchResult[index].name);
			}
			this.show[index] = display;
			this.show = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.show));
		},
		download: function download(path, location) {

			path = path.replace(/\\/g, "/");
			var filename = path.substring(path.lastIndexOf("/") + 1);
			path = encodeURI(path);

			this.axios.post(this.$bus.mamServer + "/download", { path: path, location: location }).then(function (result) {

				var data = result.data;
				console.log(result);
				if (data.status === "success") {
					var dlink = document.createElement("a");
					var url = result.data.link.replace("sharing", "fsdownload") + "/" + encodeURI(filename);
					window.open(url, "download", "width=300,height=250");
				}
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	created: function created() {
		var _this2 = this;

		this.$bus.$on("searchChanged", function (data) {

			_this2.searchResult = []; //clear 

			_this2.axios.post(_this2.$bus.mamServer + "/find", data).then(function (result) {

				if (!result.data.length) return; //no result..
				result.data.forEach(function (item, index) {
					_this2.show[index] = false;
				});

				//search for occurences???
				if (result.data[0].multiple) {
					_this2.searchOccurs = true;

					if (result.data.length < _this2.perpage) {
						_this2.searchResults = [];
						_this2.pages = 0;
						_this2.searchResult = result.data;
					} else {
						//create pages...
						_this2.pages = Math.floor(result.data.length / _this2.perpage);
						_this2.searchResults = result.data;
						_this2.searchResult = _this2.searchResults.slice(0, _this2.perpage - 1);
						document.getElementsByName("page1")[0].classList.add("pageNumberSelected");
					}
					return;
				} else {
					_this2.searchOccurs = false;
				}

				result.data.sort(function (a, b) {
					switch (_this2.sortMethod) {
						case "date":
							return new Date(b.ctime) - new Date(a.ctime);
						case "default":
							return a.name > b.name;
					}
				});

				if (result.data.length < _this2.perpage) {
					_this2.searchResults = [];
					_this2.pages = 0;
					_this2.searchResult = result.data;
				} else {
					//create pages...
					_this2.pages = Math.floor(result.data.length / _this2.perpage);
					_this2.searchResults = result.data;
					_this2.searchResult = _this2.searchResults.slice(0, _this2.perpage - 1);
					document.getElementsByName("page1")[0].classList.add("pageNumberSelected");
				}
			}).catch(function (err) {
				console.log(err);
			});
		});

		if (!this.$bus.login) return this.$router.push("/");
	}
});

/***/ }),

/***/ "HIbB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"_setting"}},[_c('h1',[_vm._v("SETTING")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"menuTab"},[_vm._v("GENERAL")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("USERS")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("GROUP")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("LOCATIONS")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("CATEGORIES")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("TAGS")]),_vm._v(" "),_c('div',{staticClass:"menuTab"},[_vm._v("BACKUP")]),_vm._v(" "),_c('div',{staticClass:"menuTab",on:{"click":_vm.checkformat}},[_vm._v("CHECK FORMAT")])]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"location settingContent"},[_vm._v("\n\t\n\t\tLOCATION SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD LOCATION"),_c('br'),_vm._v("\n\t\tREMVOE LOCATION"),_c('br'),_vm._v("\n\t\tEDIT LOCATION"),_c('br'),_vm._v("\n\t\t\n\t\t//locations....\n\t\t"),_c('hr'),_vm._v(" "),_vm._l((_vm.locations),function(location){return _c('div',[_c('table',{staticClass:"locationTable",staticStyle:{"width":"600px"}},[_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Name\t\t")]),_c('td',[_vm._v(_vm._s(location.name))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Base Path\t")]),_c('td',[_vm._v(_vm._s(location.base))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("API\t\t\t")]),_c('td',[_vm._v(_vm._s(location.api))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("INFO\t\t")]),_c('td',[_vm._v(_vm._s(location.info))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("AUTH\t\t")]),_c('td',[_vm._v(_vm._s(location.auth))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Create Share")]),_c('td',[_vm._v(_vm._s(location.createShare))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Delete Share")]),_c('td',[_vm._v(_vm._s(location.deleteShare))])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"field"},[_vm._v("Logout\t\t")]),_c('td',[_vm._v(_vm._s(location.logout))])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"}}),_vm._v("ALLOW SEARCH \t"),_c('br'),_vm._v(" "),_c('input',{attrs:{"type":"checkbox"}}),_vm._v("ALLOW DOWNLOAD\t"),_c('br'),_vm._v(" "),_c('hr')])})],2),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(5)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"general settingContent"},[_vm._v("\n\t\n\t\tGENERAL SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tSHOW PAGES "),_c('input',{attrs:{"type":"checkbox","name":"showPage"}}),_c('br'),_vm._v("\n\t\tITEMS PER PAGE "),_c('input',{attrs:{"type":"number","name":"perPage","width":"3"}}),_c('br'),_vm._v("\n\t\tMAXIMUM LOGIN TRIES "),_vm._v("\"loginTries\" width=\"3\">"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user settingContent"},[_vm._v("\n\t\n\t\tUSER SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD USER"),_c('br'),_vm._v("\n\t\tREMVOE USER"),_c('br'),_vm._v("\n\t\tEDIT USER"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group settingContent"},[_vm._v("\n\t\n\t\tGROUP SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD GROUP"),_c('br'),_vm._v("\n\t\tREMVOE GROUP"),_c('br'),_vm._v("\n\t\tEDIT GROUP"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"categories settingContent"},[_vm._v("\n\t\n\t\tCATEGORIES SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD CATEGORY"),_c('br'),_vm._v("\n\t\tREMVOE CATEGORY"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tags settingContent"},[_vm._v("\n\t\n\t\tTAGS SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tADD TAGS"),_c('br'),_vm._v("\n\t\tREMVOE TAGS"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backup settingContent"},[_vm._v("\n\t\n\t\tBACKUP SETTING ::"),_c('br'),_c('br'),_vm._v("\n\t\t\n\t\tBackup Now"),_c('br'),_vm._v("\n\t\tBackup Schedule"),_c('br'),_vm._v("\n\t\tRestotre Backup"),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IvK7":
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ "Jujc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687c8b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("foLR");
function injectStyle (ssrContext) {
  __webpack_require__("63qs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_687c8b92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_topMenu_vue__ = __webpack_require__("QmEW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_filter_vue__ = __webpack_require__("rUbY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SETTING_vue__ = __webpack_require__("92wT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_STATUS_vue__ = __webpack_require__("cS4j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_md5__ = __webpack_require__("pMqz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_md5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_md5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('topMenu', __WEBPACK_IMPORTED_MODULE_3__components_topMenu_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('searchFilter', __WEBPACK_IMPORTED_MODULE_4__components_filter_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('SETTING', __WEBPACK_IMPORTED_MODULE_5__components_SETTING_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('STATUS', __WEBPACK_IMPORTED_MODULE_6__components_STATUS_vue__["a" /* default */]);

//global
var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  data: {
    mamServer: "http://71.4.56.4:2001",
    login: false
  }
});

Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, "$md5", { value: __WEBPACK_IMPORTED_MODULE_7_md5___default.a });
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, "axios", { value: __WEBPACK_IMPORTED_MODULE_8_axios___default.a });
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, "$bus", { value: bus });

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OovG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLogin),expression:"isLogin"}],attrs:{"id":"_topMenu"}},[_c('div',{attrs:{"id":"searchBox"}},[_c('div',{staticClass:"mainHeader"},[_vm._v("VIETV MEDIA ASSETS")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchValue),expression:"searchValue"}],attrs:{"type":"text","placeholder":"search","size":"100"},domProps:{"value":(_vm.searchValue)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchValue=$event.target.value}}}),_vm._v(" "),_c('div',{staticStyle:{"display":"inline-block"}},[_c('button',{attrs:{"id":"favBtn"},on:{"click":function($event){_vm.displayFavorites=!_vm.displayFavorites}}},[_vm._v("@")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayFavorites),expression:"displayFavorites"}],attrs:{"id":"favorites"}},_vm._l((_vm.searchFavorites),function(item){return _c('li',{on:{"click":function($event){_vm.searchValue=item;_vm.displayFavorites=false}}},[_vm._v(_vm._s(item))])}))]),_vm._v(" "),_c('button',{on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v(" "),_c('button',{on:{"click":_vm.toggleFilter}},[_vm._v("Filter")])]),_vm._v(" "),(_vm.isLogin)?_c('button',{attrs:{"id":"loginBtn"},on:{"click":_vm.logout}},[_vm._v("Logout")]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":"/setting"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"id":"settingBtn"}},[_vm._v("Setting")])]),_vm._v(" "),_c('button',{attrs:{"id":"statusBtn"},on:{"click":_vm.toggleStatus}},[_vm._v("Status")]),_vm._v(" "),_c('searchFilter',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilter),expression:"showFilter"}],on:{"toggleFilter":_vm.toggleFilter,"filterUpdate":function($event){_vm.searchFilters=$event}}}),_vm._v(" "),_c('STATUS',{directives:[{name:"show",rawName:"v-show",value:(_vm.showStatus),expression:"showStatus"}],attrs:{"statusInfo":_vm.statusInfo},on:{"toggleStatus":_vm.toggleStatus}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "QmEW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topMenu_vue__ = __webpack_require__("7JBw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad95172_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topMenu_vue__ = __webpack_require__("OovG");
function injectStyle (ssrContext) {
  __webpack_require__("Jujc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6ad95172"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_topMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ad95172_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_topMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T5Do":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'STATUS',
  props: ['statusInfo'],
  data: function data() {
    return {};
  },

  methods: {},
  created: function created() {
    //console.log("satus created...")
  }
});

/***/ }),

/***/ "TfZk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login__ = __webpack_require__("xJsL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Setting__ = __webpack_require__("cbWt");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  history: true,
  hashbang: false,
  mode: "history",
  routes: [{
    path: '/',
    name: 'LOGIN',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Login__["a" /* default */]
  }, {
    path: '/HOME',
    name: 'HOME',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/SETTING',
    name: 'SETTING',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Setting__["a" /* default */]
  }]
}));

/***/ }),

/***/ "ZFg+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'filter',
	data: function data() {
		return {
			filterLimits: 10,
			filterLastDays: 14,
			filterLocations: '',
			filterCategory: '',
			filterTags: '',
			filterWidth: '',
			filterHeight: '',
			searchFilters: {},
			categories: ["", "ads", "shows", "music", "news", "pscd", "infomercial", "movie", "hai kich"]
		};
	},

	methods: {
		closeFilter: function closeFilter() {
			this.$emit('toggleFilter', true);
		},
		updateFilter: function updateFilter() {
			this.searchFilters = {
				filterLimits: this.filterLimits,
				filterLastDays: this.filterLastDays,
				filterLocation: this.filterLocations,
				filterCategory: this.filterCategory,
				filterTags: this.filterTags,
				filterWidth: this.filterWidth,
				filterHeight: this.filterHeight
			};
			this.$emit('filterUpdate', this.searchFilters);
		}
	},
	created: function created() {
		this.updateFilter();
	}
});

/***/ }),

/***/ "cS4j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_STATUS_vue__ = __webpack_require__("T5Do");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0c30358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_STATUS_vue__ = __webpack_require__("qKhR");
function injectStyle (ssrContext) {
  __webpack_require__("/Pp4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0c30358"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_STATUS_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0c30358_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_STATUS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cbWt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__ = __webpack_require__("4Skl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9065ba9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__ = __webpack_require__("CP5k");
function injectStyle (ssrContext) {
  __webpack_require__("hFvP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9065ba9c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Setting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9065ba9c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Setting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "foLR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('topMenu'),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gzbu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hFvP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_887aa3ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("95NA");
function injectStyle (ssrContext) {
  __webpack_require__("gzbu")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-887aa3ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_887aa3ee_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'login',
	data: function data() {
		return {
			username: "",
			password: ""
		};
	},

	methods: {

		login: function login() {
			var _this = this;

			this.axios.post(this.$bus.mamServer + "/login", { username: this.username, password: this.$md5(this.password) }).then(function (result) {

				var data = result.data;
				if (data.status === "authenticated") {
					_this.$bus.login = { user: _this.username, token: data.token, expired: data.expired };
					localStorage.setItem("token", data.token);
					localStorage.setItem("user", _this.username);
					localStorage.setItem("expired", data.expired);
					_this.$bus.$emit('loggedin');
					//redirect to home
					_this.$router.push("/home");
				} else alert("Something wrong...");
			}).catch(function (err) {
				console.log(err);
			});
		}

	},
	created: function created() {

		if (!this.$bus.login) {
			var token = localStorage.getItem("token");
			var user = localStorage.getItem("user");
			var expired = localStorage.getItem("expired");
			console.log(token + "::" + expired + "::" + Date.now());
			if (token != null && expired > Date.now()) {
				this.$bus.login = { user: user, token: token };
				this.$router.push("/home");
				this.$bus.$emit('loggedin');
			}
		}
	}
});

/***/ }),

/***/ "oB3b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pMqz":
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__("pqbr"),
      utf8 = __webpack_require__("IvK7").utf8,
      isBuffer = __webpack_require__("q/Zl"),
      bin = __webpack_require__("IvK7").bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),

/***/ "pqbr":
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ "q/Zl":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "qKhR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"_status"}},[_vm._v("\n\n\n\t::STATUS::"),_c('br'),_vm._v(" "),_c('div',{staticStyle:{"float":"left"}},_vm._l((_vm.statusInfo),function(location,index){return (_vm.statusInfo.length)?_c('div',{class:'locationStatus '+location.status},[_vm._v("\n\t\t\tLocation: "+_vm._s(location.location)),_c('br'),_vm._v("\n\t\t\tStatus: "+_vm._s(location.status)),_c('br'),_vm._v("\n\t\t\tLast Beat: "+_vm._s(location.lastBeat)),_c('br')]):_vm._e()}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rUbY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_vue__ = __webpack_require__("ZFg+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd062de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_vue__ = __webpack_require__("DEyW");
function injectStyle (ssrContext) {
  __webpack_require__("oB3b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2dd062de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_filter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2dd062de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_filter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c2ae2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("Ephl");
function injectStyle (ssrContext) {
  __webpack_require__("BaCP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53c2ae2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c2ae2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xcFv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'SETTING',
	data: function data() {
		return {
			locations: [{ name: "PENDING", base: "/ftp.tv.pending", api: "https://192.168.40.31:5001/webapi", info: "info query", auth: "auth", createShare: "test", deleteShare: "delete", logout: "logout" }, { name: "PENDING2", base: "/ftp.tv.pending", api: "https://192.168.40.31:5001/webapi", info: "info query", auth: "auth", createShare: "test", deleteShare: "delete", logout: "logout" }]
		};
	},

	methods: {
		checkformat: function checkformat() {
			this.axios.post(this.$bus.mamServer + "/checkformat", { key: "secretcode2018" }).then(function (result) {

				var data = result.data;
				console.log(result);
				if (data.status === "success") {}
			}).catch(function (err) {
				console.log(err);
			});
		}
	},
	created: function created() {
		var _this = this;

		//get locations
		this.axios.post(this.$bus.mamServer + "/getLocationInfos").then(function (result) {
			_this.locationInfos = result.data;
		}).catch(function (err) {
			console.log(err);
		});
	}
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.77f0f5de856204d8780b.js